import { map } from "lodash";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Table from "../../Common/Tables/BaseTable";
import VedtakskoderModal from "./UpdateModals/VedtakskoderModal";

import { getVedtakskoder } from "../../../actions/vedtakskoderAction";
import * as title from "../../../constants/titles";
import { datetimeIsDeactivated } from "../../../utils/date";

export default function VedtakskoderList({ authorizedToCreateAndEdit, modalToRender }) {
  const dispatch = useDispatch();
  const vedtakskoder = useSelector((state) => state.vedtakskoder);
  const vedtakskoderAktivStatus = useSelector(
    (state) => state.forms.grunndataFilterForm.vedtakskoderAktivStatus
  );

  useEffect(() => {
    document.title = title.grunndataVedtakskoder;
    dispatch(getVedtakskoder());
  }, [dispatch]);

  const selectedIleggelsetyper = (vedtakskode) => {
    if (vedtakskode.ileggelsetyper) {
      const arr = map(vedtakskode.ileggelsetyper, (i) => i.kode);
      const filtered = arr.filter(Boolean);
      if (filtered.length > 0) return filtered.join(", ");
    }
  };

  const selectedIleggelsetypeIds = (vedtakskode) => {
    if (vedtakskode.ileggelsetyper) {
      return map(vedtakskode.ileggelsetyper, (i) => i.id);
    }
    return [];
  };

  const headerRow = [
    "ID",
    "Kode",
    "Tekst",
    "Mehold",
    "Klagekode",
    "Ileggelsestyper",
    "Til INE",
    "Status",
    "",
  ];

  const filtered = vedtakskoder.filter(
    (vk) =>
      !datetimeIsDeactivated(vk.deaktivertDato) === vedtakskoderAktivStatus ||
      vedtakskoderAktivStatus === null
  );

  return (
    <div className="table-wrapper-horizontal-scroll">
      <Table id="vedtakskoder-liste" headerRow={headerRow} defaultStyle striped>
        <tbody>
          {map(filtered, (vedtakskode) => (
            <tr key={`vedtakskoderTableBodyTr${vedtakskode.id}`}>
              <td>{vedtakskode.id}</td>
              <td>{vedtakskode.kode}</td>
              <td>{vedtakskode.navn}</td>
              <td>{vedtakskode.klagekode ? vedtakskode.klagekode.navn : "-"}</td>
              <td>{vedtakskode.klagekode ? vedtakskode.klagekode.id : "-"}</td>
              <td>{selectedIleggelsetyper(vedtakskode)}</td>
              <td>{vedtakskode.tilkemner ? vedtakskode.tilkemner : ""}</td>
              <td>
                {datetimeIsDeactivated(vedtakskode.deaktivertDato)
                  ? "Deaktivert"
                  : "Aktiv"}
              </td>
              <td>
                {authorizedToCreateAndEdit && (
                  <VedtakskoderModal
                    modalToRender={modalToRender}
                    vedtakskode={vedtakskode}
                    selectedIleggelsestyper={selectedIleggelsetypeIds(vedtakskode)}
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

